import CoreService from '../Services/CoreService';
import { createAction, createReducer } from '@reduxjs/toolkit';
import { frc } from 'front-end-common';

const { getDefaultHandler, getDefaultState } = frc.utils.reducerTools;

const getNonManagerCustomerInitState = () => ({
  isLoading: false,
  isInitialized: false,
  error: null,
});


export const coreFetchCustomers = createAction('core/customers', () => ({
  payload: CoreService.fetchCustomers(),
}))

export const coreFetchSelectedCustomers = createAction('core/customersSelected', () => ({
  payload: CoreService.fetchCustomersSelected(),
}))

export const fetchSelectedCustomers = createAction('core/customersSettingsSelected', () => ({
  payload: CoreService.fetchCustomersSettings(),
}))

export const coreSetSelectedCustomers = createAction('core/setCustomersSettingsSelected', (data) => ({
  payload: CoreService.changeCustomersSettings(data),
}))

export const fetchAccountData = createAction('core/account', () => ({
  payload: CoreService.fetchAccountData()
}))

export const setCreditLimit = createAction('core/creditLimit', (data) => ({
  payload: CoreService.setCustomerCreditLimit(data)
}))

export const setCustomerSelfApproval = createAction('core/selfApproval', ({ customerId, selfApproval }) => ({
  payload: CoreService.setCustomerSelfApproval(customerId, selfApproval)
}))

export const setCustomerSelfApprovedOrderLimit = createAction(
  'core/selfApprovedOrderLimit',
  ({ customerId, selfApprovedOrderLimit }) => ({
    payload: CoreService.setCustomerSelfApprovedOrderLimit(customerId, selfApprovedOrderLimit)
  })
)

export const coreSetCurrentCustomer = createAction('core/customer', (customer) => ({
  payload: customer,
}))

export const coreStartNonManagerCustomerInit = createAction('core/non-manager-customer-init-start')

export const coreCompleteNonManagerCustomerInit = createAction('core/non-manager-customer-init-complete')

export const coreFailNonManagerCustomerInit = createAction('core/non-manager-customer-init-fail', (error) => ({
  payload: error,
}))

export const coreResetCustomerContext = createAction('core/customer-context-reset')

const initState = {
  customers: getDefaultState(),
  customersSelected: getDefaultState(),
  customersSettingsSelected: getDefaultState(),
  setCustomersSettingsSelected: getDefaultState(),
  account: getDefaultState(),
  creditLimit: getDefaultState(),
  selfApproval: getDefaultState(),
  selfApprovedOrderLimit: getDefaultState(),
  customer: '',
  nonManagerCustomerInit: getNonManagerCustomerInitState(),
};

export default createReducer(initState, {
  ...getDefaultHandler(coreFetchCustomers, 'customers'),
  ...getDefaultHandler(coreFetchSelectedCustomers, 'customersSelected'),
  ...getDefaultHandler(fetchSelectedCustomers, 'customersSettingsSelected'),
  ...getDefaultHandler(coreSetSelectedCustomers, 'setCustomersSettingsSelected'),
  ...getDefaultHandler(fetchAccountData, 'account'),
  ...getDefaultHandler(setCreditLimit, 'creditLimit'),
  ...getDefaultHandler(setCustomerSelfApproval, 'selfApproval'),
  ...getDefaultHandler(setCustomerSelfApprovedOrderLimit, 'selfApprovedOrderLimit'),
  [coreSetCurrentCustomer]: (state, action) => {
    state.customer = action.payload;
  },
  [coreStartNonManagerCustomerInit]: (state) => {
    state.customer = '';
    state.nonManagerCustomerInit = {
      isLoading: true,
      isInitialized: false,
      error: null,
    };
  },
  [coreCompleteNonManagerCustomerInit]: (state) => {
    state.nonManagerCustomerInit = {
      isLoading: false,
      isInitialized: true,
      error: null,
    };
  },
  [coreFailNonManagerCustomerInit]: (state, action) => {
    state.customer = '';
    state.nonManagerCustomerInit = {
      isLoading: false,
      isInitialized: false,
      error: action.payload,
    };
  },
  [coreResetCustomerContext]: (state) => {
    state.account = getDefaultState();
    state.customer = '';
    state.nonManagerCustomerInit = getNonManagerCustomerInitState();
  },
})
